/**
 * Kaydırınca gizlenen üst şerit.
 *
 * ## Betiksiz denendi, olmadı
 *
 * Bu depoda ve v3'te betiksiz çözüm alışkanlığı var, o yüzden önce CSS denendi ve **ölçüldü**
 * (21.08.2026, Chrome 151):
 *
 *   - `animation-timeline: scroll()` **destekleniyor**, ama kaydırmanın **konumunu** veriyor,
 *     yönünü değil. Yani "belli bir noktadan sonra gizle" yazılabilir, "aşağı inerken gizle,
 *     yukarı çıkarken göster" yazılamaz.
 *   - `container-type: scroll-state` **destekleniyor** görünüyor, ama yön sorgusu çalışmıyor:
 *     `@container scroll-state(scrolling: down)` kuralı yazılıp aşağı ve yukarı kaydırıldığında
 *     şeridin rengi hiç değişmedi. Yani sorgu bugün bu tarayıcıda uygulanmıyor.
 *
 * Ürün sahibinin istediği davranış **yöne bağlı** ("scrollda topbar hidden olsun"), yani bugün
 * CSS ile yazılamıyor. Bu yüzden bir betik var ve **on satır**: kaydırma yönünü ölçüp bir sınıf
 * ekliyor, gerisini CSS yapıyor. Yön sorgusu yaygınlaştığında bu dosya silinir ve CSS kalır.
 *
 * ## Hareketi azaltan kullanıcı
 *
 * `prefers-reduced-motion: reduce` açıkken şerit **hiç gizlenmiyor**. Gizlenip geri gelen bir
 * şerit bir harekettir ve o ayarı açan kişi bunu istemiyor; CSS'te geçişi kapatıp şeridi
 * kaydırmaya devam ettirmek, hareketi azaltmak değil onu ani hâle getirmek olurdu.
 */

/** Bu eşiğin altında şerit hep görünür: sayfanın başındayken gizlemek anlamsız. */
const ESIK = 96;

/** Titremeyi önleyen en küçük hareket: bir pikselde bir gizlenip bir görünen şerit kusurdur. */
const OLU_BOLGE = 8;

export function seridiIzle(): () => void {
  const azHareket = window.matchMedia('(prefers-reduced-motion: reduce)');
  let sonY = window.scrollY;
  let bekleyen = false;

  const uygula = () => {
    bekleyen = false;
    const y = window.scrollY;
    const fark = y - sonY;
    if (Math.abs(fark) < OLU_BOLGE) return;
    sonY = y;
    const gizle = !azHareket.matches && y > ESIK && fark > 0;
    document.documentElement.classList.toggle('serit-gizli', gizle);
  };

  const dinle = () => {
    if (bekleyen) return;
    bekleyen = true;
    window.requestAnimationFrame(uygula);
  };

  window.addEventListener('scroll', dinle, { passive: true });
  return () => window.removeEventListener('scroll', dinle);
}
